import { AxiosError } from "axios";
import { ErrorCode, ResponseStatus } from "./response";
// import ERROR_CODE_MESSAGE from '@/i18n/message';

// export enum PageType {
//     ORGANIZATION = 'Organization',
//     CATEGORY = 'Category',
//     MATERIAL = 'Material',
//     USER = 'User',
//     ALERT = 'Alarm',
//     INVENTORY = 'Inventory',
//     PERSONAL_SETTING = 'PersonalSetting',
// }

interface ErrorResponse {
    message: string;
}

export function getErrorMessage(error: Error): string {

    if (error instanceof AxiosError) {
        if (error.status === undefined) {
            return 'APIリクエストでレスポンスデータが取得できませんでした';
        } else {
            if (error.status in ResponseStatus) {
                if (error.response?.data === undefined) {
                    return 'APIリクエストでステータス情報が取得できませんでした';
                } else {
                    return (error.response?.data as ErrorResponse).message;
                }
            } else {
                return 'サーバー側で予期せぬエラーが発生しました';
            }
        }
    }

    // unknown error
    return '予期せぬエラーが発生しました';
}
